import { FC } from "react";
import styles from "./NoData.module.sass";

interface NoDataProps {
	title: string;
}

export const NoData: FC<NoDataProps> = ({ title }) => {
	return (
		<div data-comment-false={true} className={styles.wrp}>
			{title}
		</div>
	);
};
